import { SourcingCompany } from '@dustin-web/microsite-config'
import { Translator } from '@eo-locale/core'
import { useUserSettings } from '@dustin-web/microsite-components/src/hooks'
import useShoppingCart from '@dustin-web/product-components/src/hooks/dataloader/use-shopping-cart'

export const useSuggestedDeliveryFee = () => {
  const { showPricesInclVat } = useUserSettings()
  const { suggestedDelivery } = useShoppingCart()

  const shippingFeeVat = suggestedDelivery?.shippingFeeVat ?? 0
  const suggestedDeliveryFeeExcludingVat = suggestedDelivery?.shippingFeeExcludingVat ?? 0
  const suggestedDeliveryFeeIncludingVat = suggestedDeliveryFeeExcludingVat + shippingFeeVat
  const suggestedDeliveryFee = showPricesInclVat
    ? suggestedDeliveryFeeIncludingVat
    : suggestedDeliveryFeeExcludingVat

  const suggestedDeliveryInsuranceFeeExcludingVat =
    suggestedDelivery?.shippingInsuranceFeeExcludingVat ?? 0
  const suggestedDeliveryInsuranceFeeIncludingVat =
    suggestedDeliveryInsuranceFeeExcludingVat + (suggestedDelivery?.shippingInsuranceFeeVat ?? 0)
  const suggestedDeliveryInsuranceFee = showPricesInclVat
    ? suggestedDeliveryInsuranceFeeIncludingVat
    : suggestedDeliveryInsuranceFeeExcludingVat

  return {
    suggestedDeliveryFee,
    shippingFeeVat,
    suggestedDeliveryFeeExcludingVat,
    suggestedDeliveryFeeIncludingVat,
    suggestedDeliveryInsuranceFee,
  }
}

export const freeShippingAmountB2C = (sourcingCompany: SourcingCompany) => {
  switch (sourcingCompany) {
    case 'SE':
      return 3000

    case 'DK':
      return 2000

    case 'FI':
      return 300

    case 'NO':
      return 3000

    case 'NL':
      return 50

    default:
      return 0
  }
}

export const palletShippingAmountB2C = (sourcingCompany: SourcingCompany, deliveryFee: number) => {
  const palletsFee = {
    SE: 399,
    DK: 399,
    FI: 79,
    NO: 799,
    NL: 36,
    BE: 36, // TODO: Add pallet shipping amount for Belgium? Then again B2C is not needed in Belgium
  }

  if (!(sourcingCompany in palletsFee)) {
    return false
  } else {
    return deliveryFee <= palletsFee[sourcingCompany]
  }
}

export const getCartItemsCountText = (itemCount: number, translate: Translator['translate']) => {
  if (itemCount === 0) {
    return translate('Cart_Header_EmptyCart')
  }

  if (itemCount === 1) {
    return translate('Cart_Header_OneItem')
  }

  return translate('Cart_Header_SeveralItems', {
    itemCount,
  })
}

export const getMaxQuantity = (
  parentQuantity = 0,
  maxQuantityPerOrder: number | null | undefined
) => {
  if (maxQuantityPerOrder == null) {
    return 0
  }

  if (parentQuantity > 0 && (maxQuantityPerOrder >= parentQuantity || maxQuantityPerOrder === 0)) {
    return parentQuantity
  }
  return maxQuantityPerOrder
}
